import { Component, Inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { InputGeneralComponent } from '../input-general/input-general.component';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { AuthService } from 'app/auth/auth.service';

type AccountUnverifiedUserDetails = {
    username?: string;
    email?: string;
};

@Component({
    selector: 'app-account-unverified-modal',
    templateUrl: './account-unverified-modal.component.html',
    styleUrls: ['./account-unverified-modal.component.scss'],
    imports: [
        InputGeneralComponent,
        CommonModule,
        TranslateModule,
        MatIconModule,
    ],
    standalone: true,
})
export class AccountUnverifiedModalComponent {
    userDetails: AccountUnverifiedUserDetails;

    constructor(
        public dialogRef: MatDialogRef<AccountUnverifiedModalComponent>,
        private router: Router,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private authService: AuthService,
    ) {
        this.userDetails = data?.userDetails || {};
    }

    onDialogClose(result: boolean): void {
        this.dialogRef.close();
    }

    sendVerificationCode(): void {
        const navigationExtras = {
            state: { userDetails: {username: this.userDetails.username,  email: this.userDetails.email} },
        };
        const sendDetails = {
            username: this.userDetails.username || '',
            email: this.userDetails.email || '',
        };
        this.authService.sendVerificationEmail(sendDetails).subscribe({
            next: () => {
                this.onDialogClose(true);
                this.router.navigate(['/resend-code'], navigationExtras);
            },
            error: (err) => {
                console.error('Failed to send verification email', err);
            },
        });
    }

    backToLogin(): void {
        this.onDialogClose(false);
        this.router.navigate(['/login']);
    }
}
